import toastr from 'toastr';
import messages from './messages';

const errorManage = (ex, dispatch, failureActionType) => {
  let message = '';
  if(ex.response){
    switch (ex.response.status) {
      case 400:
        message = ex.response.data;
        toastr.error(message.error || messages.badRequest);
        break;
      case 401:
        localStorage.removeItem('auth');
        window.location.href = '/';
        break;
      case 404:
        toastr.info(messages.notFound);
        message = messages.notFound;
        break;
      case 500:
        toastr.error(messages.serverError);
        message = messages.serverError;
        break
      default:
        toastr.error(messages.errorMessage);
        message = messages.errorMessage;
        break;
    }
  }else if (ex.request){
    toastr.error(messages.serverNotResponse);
    message = messages.serverNotResponse
  }else{
    toastr.error(messages.requestConfigError);
    message = messages.requestConfigError;
  }
  if(dispatch){
    dispatch({ type: failureActionType, payload: message });
  }
}

export default errorManage;